import {Actions} from '@redstack/shared'
import {createFileRoute} from '@tanstack/react-router'
import {TeamDashboardPreview} from '@/features/dashboard/TeamDashboardPreview'
import {useRequirePermission} from '@/hooks/useRequirePermission'

function DashboardPreviewRoute() {
	if (!useRequirePermission(Actions.DASHBOARD_VIEW)) return null
	return <TeamDashboardPreview />
}

export const Route = createFileRoute('/dashboard/preview')({
	component: DashboardPreviewRoute,
})
